import { useTranslation } from 'react-i18next';
import './ContentNotAvailable.scss';

const ContentNotAvailable: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="content-not-available-page">
      <img
        src={'/assets/images/content-not-available.svg'}
        alt="403 Content Not Available"
      />
      <h1 className="title-lg">{t('contentNotAvailableTitle')}</h1>
      <h2 className="title-md">{t('contentNotAvailableBody')}</h2>
    </div>
  );
};

export default ContentNotAvailable;
